
// require('../js/vendors/jquery.paroller');
// require('../../../../node_modules/paroller.js/assets/main');  
// require('../../../../node_modules/paroller.js/dist/jquery.paroller');  


import "../../../js/vendors/jquery.paroller";


jQuery(".lax-scroll-1").paroller({ 
    factor: 0.1, 
    factorSm: 0.01,
    type: 'foreground',
});
jQuery(".lax-scroll-2").paroller({ 
    factor: 0.2, 
    factorSm: 0.02,
    type: 'foreground' 
});
jQuery(".lax-scroll-3").paroller({ 
    factor: 0.3, 
    factorSm: 0.03,
    type: 'foreground' 
});

